import { render, staticRenderFns } from "./Login.vue?vue&type=template&id=a8c7b9de&"
import script from "./Login.vue?vue&type=script&lang=js&"
export * from "./Login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)


    import installComponents from "!C:/Projects/rentmagic.website.vue.limburg/node_modules/bootstrap-vue-loader/lib/runtime/installComponents.js"
    import {BFormInput, BFormGroup, BButton, BInputGroupAppend, BInputGroup, BCol, BRow, BForm, BCard, BAlert} from 'bootstrap-vue'
    installComponents(component, {BFormInput, BFormGroup, BButton, BInputGroupAppend, BInputGroup, BCol, BRow, BForm, BCard, BAlert})
    

export default component.exports